/* @flow */
import AdminSisSyncProcessingView from './AdminSisSyncProcessingView';

export default AdminSisSyncProcessingView;
